import Vue from 'vue'
import Vuex from 'vuex'
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
Vue.use(Vuex)

const state = {
  isCollapse: true,
  adminleftnavnum: '/home', //管理后台左侧导航
  //language: localStorage.getItem('user_lang') || 'zh',
  language: localStorage.getItem('user_lang') ||  Globals.DefaultLanguage,
  chinaJson:"",
  menuListState:[],
  authOperationState:[],
  route:""
}
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {}
})
